import type { CSSProperties } from 'react';
import { de } from '../i18n/de';
import type { ConsequenceLine } from '../lib/consequences';

/**
 * Folgen einer Bewegung, solange man zieht (PF 55): je Zeile, was danach neu nicht passt (⚠), sich auflöst (✓) bzw. mitwandert (↷). Auf
 * der Fläche unter der gezogenen Szene, im Binder und in der Erzähllinie an der Einfügestelle. Ohne Folgen nichts.
 */
export function ConsequenceList({ lines, className, style, testId }: { lines: ConsequenceLine[]; className: string; style?: CSSProperties; testId: string }) {
  if (lines.length === 0) return null;
  return (
    <div className={className} style={style} role="status" aria-label={de.consequences.title} data-testid={testId}>
      {lines.map((l, i) => (
        <div key={i} className={`dc-line ${l.kind}`} data-kind={l.kind}>
          {l.kind === 'added' ? '⚠ ' : l.kind === 'resolved' ? '✓ ' : '↷ '}
          {l.text}
        </div>
      ))}
    </div>
  );
}
